module.exports = __webpack_public_path__ + "img/logout-warning-icon.71f1b8b3.svg";